import CustomForm from "../CustomForm";
import {TextboxItem} from "../../model/items/textbox";
import ICustomFormSettings from "../ICustomFormSettings";
import moment from "moment";

export default abstract class Record extends CustomForm {

    protected readonly output?: TextboxItem;

    constructor(settings: ICustomFormSettings) {
        super(settings);
        this.output = <TextboxItem|undefined>settings.form.grid?.layout[0][1]?.cellItems[0];
    }

    checkRequirements(): boolean {
        if (!this.output) {
            console.log('customForm-Record: Missing Textbox field for saving record.');
            return false;
        }

        return super.checkRequirements();
    }

    protected log(record: string|string[]): void {
        const questionaryId = this.settings.form.questionary.api.questionaryId;
        const datetime = moment().format('YYYY-MM-DD HH:mm:ss');
        const row = questionaryId +','+ datetime +','+ (Array.isArray(record) ? record.join(',') : record);
        const currentLog = this.output!.getVariable() || '';
        this.output!.set(currentLog + row + '\n');
    }
}